export const TOGGLE_SNACKBAR = "TOGGLE_SNACKBAR";

export function toggleSnackbar(status, message) {
    return {
        type: TOGGLE_SNACKBAR,
        status,
        message
    }
}
